import ComponentBoxFooter from '../../components/ComponentBox/ComponentBoxFooter/ComponentBoxFooter'

const Register = () => {
    return (
       <ComponentBoxFooter children={<div id='register_p'>
          New user? <a href='/ui/register'> 
            Register here <p className='external' />
          </a>  
        </div>}/>
    )
  }

export default Register
  